module.exports = __webpack_public_path__ + "img/moontowerlogo.8af5c568.png";